import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { IFilterFacetItem } from '@impact/data';
import * as icons from '../../../icons';
import { FacetStateService } from '../../core/facet-state.service';
import { ExpansionPanelComponent } from '../../expansion-panel/expansion-panel.component';
import { FilterService } from '../../filter-service/filter.service';
import { COLLAPSE_PANELS } from '../../models/filter.models';

interface IPurchaseOption {
    label: string;
    item: IFilterFacetItem;
}

@Component({
    selector: 'app-facet-leasing',
    template: `
        <div class="facet">
            <app-expansion-panel #panel [headerClickable]="true" [expanded]="expandPanel" (changed)="onPanelChange($event)">
                <h6 class="facet__title" expansion-title [class.facet__title--no-margin]="!panel.animating && !panel.expanded">
                    {{ 'filterpage.facet_leasing_heading' | translate }}
                </h6>
                <span expansion-icon [innerHTML]="icons.chevronDownIcon | safe: 'html'"></span>

                <label class="switch" *ngFor="let facet of facets?.items">
                    <input type="checkbox" [checked]="facet?.selected" (change)="handleChange(facet)">
                    <span class="slider"></span>
                    <span class="text-left">Køb</span>
                    <span class="text-right">{{ facet.label }}</span>
                </label>
            </app-expansion-panel>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacetLeasingComponent implements OnInit {

    @Input() facets: any;

    @ViewChild('panel') panel: ExpansionPanelComponent;

    icons = icons;
    expandPanel = false;
    facetStateServiceLabel = 'facetStateService';

    constructor(
        public readonly filterService: FilterService,
        private readonly facetStateService: FacetStateService,
        @Optional() @Inject(COLLAPSE_PANELS) private collapsePanels: boolean
    ) {}

    ngOnInit(): void {
        const expandState = this.facetStateService.getExpandedState(this.facetStateServiceLabel);
        this.expandPanel = expandState ?? this.collapsePanels ?? true;
    }

    handleChange(facet: IPurchaseOption) {
        if (facet.label) {
            this.filterService.setFacet({ facet: 'purchaseOption.keyword', option: facet });
        }
    }

    onPanelChange(value: boolean) {
        if (value) {
            this.facetStateService.storeFacetAsExpanded(this.facetStateServiceLabel);
        } else {
            this.facetStateService.storeFacetAsColapsed(this.facetStateServiceLabel);
        }
    }
}
